import { render, staticRenderFns } from "./AssignedStockProductSidebar.vue?vue&type=template&id=03fbdb3a&"
import script from "./AssignedStockProductSidebar.vue?vue&type=script&lang=js&"
export * from "./AssignedStockProductSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AssignedStockProductSidebar.vue?vue&type=style&index=0&id=03fbdb3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports